/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useMemo, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Box, Tabs, Tab } from '@material-ui/core';
import ReportList from 'components/Dashboard/report-list/ReportList';
import DialogBox from '../../Shared/DialogBox';
import { resetFirstTimeUsrStatus } from 'components/UserTour/Tour.action';
import {
	RUN_NOW_MESSAGE,
	ERROR_WITH_SHARING_API,
	PROJECTS,
	GOT_IT_BTN,
	ACTIVE,
	SAVED,
	SHARED,
	BASIC,
	REPORTS,
	RECIPE,
	LAST_UPDATED_DATE,
	LAST_RUN_DATE
} from 'constants/constant';
import previewStyle from 'components/Preview/Preview.style';
import TabPanel from 'components/Template/left-panel/TabPanel';
import { setReportTypeTabValue, setSharedReportTabValue, dbSortBy } from '../Dashboard.actions';
import RBSnackbar from 'components/Shared/RBSnackbar';
import { UserPortalContext } from 'context/appcontext';
import NoDataPage from '../no-data-page/NoDataPage.component';
import NewReportButton from '../../Shared/NewReportButton';
import SearchReport from '../search-reports/SearchReports';
import bulletIcon from 'assets/svgs/bullet.svg';

const ShowErrorDialog = ({ openErrorMsg, errorMsgText, cbOnDialogCancel }) => {
	const dialogProps = {
		title: '',
		bodyContent: errorMsgText,
		secondaryBtnText: '',
		primaryBtnText: GOT_IT_BTN,
		onSecondaryClick: () => {},
		onPrimaryClick: cbOnDialogCancel
	};
	dialogProps.hideTitle = true;
	dialogProps.hidePrimaryBtn = true;
	return <DialogBox open={openErrorMsg} {...dialogProps} />;
};

function DashboardMain() {
	// eslint-disable-next-line prettier/prettier
	const tabValue = useSelector((state) => state.dashboardReducer.tabValue);
	const reportTypeTabValue = useSelector((state) => state.dashboardReducer.reportTypeTabValue);
	const reportsList = useSelector((state) => state.dashboardReducer.reportsList);
	const sharedReportList = useSelector((state) => state.dashboardReducer.sharedList);
	const runNowErrorCode = useSelector((state) => state.dashboardReducer.runNowErrorCode);
	const portalUserContext = useContext(UserPortalContext);
	const { customerType } = portalUserContext;
	const shareReportError = useSelector((state) => state.dashboardReducer.shareReportErrorCode);
	const savedReportsList = useSelector((state) => state.dashboardReducer.savedReportsList);
	const sharedReportTabValue = useSelector((state) => state.dashboardReducer.sharedReportTabValue);
	const [openErrorMsg, setOpenErrorMsg] = useState(false);
	const [errorMsgText, setErrorMsgText] = useState(RUN_NOW_MESSAGE);
	const dispatch = useDispatch();
	const classes = previewStyle();

	const [currentTab, setCurrentTab] = useState(reportTypeTabValue);
	const [currentSharedTab, setCurrentSharedTab] = useState(sharedReportTabValue);
	const [openSnackbar, setSnackbar] = useState({ open: false, msg: '' });
	const TABS = [
		{
			label: ACTIVE,
			disabled: false,
			list: reportsList,
			defaultSoryBy: LAST_RUN_DATE
		},
		{
			label: SAVED,
			disabled: false,
			list: savedReportsList,
			defaultSoryBy: LAST_UPDATED_DATE
		}
	];

	const getTabLabel = (labelText) => {
		let check = false;
		if (labelText === REPORTS) {
			check = sharedReportList.some(
				(report) =>
					(report.sharedWith.isDataIncluded === undefined ||
						report.sharedWith.isDataIncluded === true) &&
					(report.downloadCount === undefined || report.downloadCount === 0)
			);
		} else {
			check = sharedReportList.some(
				(report) =>
					report.sharedWith.isDataIncluded === false &&
					(report.downloadCount === undefined || report.downloadCount === 0)
			);
		}

		return (
			<div style={{ display: 'flex', justifyContent: 'space-between' }} id="shared-tab">
				<div style={{ display: 'flex', justifyContent: 'space-between' }}>{labelText}</div>
				{check && (
					<div style={{ alignSelf: 'center', marginTop: '-20px' }}>
						<img className={classes.bullet} src={bulletIcon} alt="bullet-icon"></img>
					</div>
				)}
			</div>
		);
	};

	const SHARED_TAB = [
		{
			label: getTabLabel(REPORTS),
			disabled: false,
			list: sharedReportList.filter(
				(report) =>
					report.sharedWith.isDataIncluded === undefined ||
					report.sharedWith.isDataIncluded === true
			),
			defaultSoryBy: LAST_RUN_DATE
		},
		{
			label: getTabLabel(RECIPE),
			disabled: false,
			list: sharedReportList.filter((report) => report.sharedWith.isDataIncluded === false),
			defaultSoryBy: LAST_UPDATED_DATE
		}
	];

	const getDisplayList = () => {
		if (tabValue === PROJECTS) {
			if (reportTypeTabValue === 1) {
				return savedReportsList;
			} else {
				return reportsList;
			}
		} else {
			if (sharedReportTabValue === 0) {
				const list = sharedReportList.filter(
					(report) =>
						report.sharedWith.isDataIncluded === undefined ||
						report.sharedWith.isDataIncluded === true
				);
				return list;
			} else {
				const list = sharedReportList.filter(
					(report) => report.sharedWith.isDataIncluded === false
				);
				return list;
			}
		}
	};

	useEffect(() => {
		setSnackbar({ open: false, msg: '' });
	}, [currentTab, currentSharedTab]);

	useEffect(() => {
		if (runNowErrorCode) {
			setOpenErrorMsg(true);
			setErrorMsgText(RUN_NOW_MESSAGE);
		}
		dispatch(resetFirstTimeUsrStatus());
	}, [runNowErrorCode]);

	useEffect(() => {
		if (shareReportError) {
			setOpenErrorMsg(true);
			setErrorMsgText(ERROR_WITH_SHARING_API);
		}
	}, [shareReportError]);

	const cbOnDialogCancel = () => {
		setOpenErrorMsg(false);
	};

	const handleIsReportSaved = (status) => {
		setSnackbar(status);
	};
	const RenderReportList = useMemo(() => {
		return (
			<Grid container direction="row">
				<Grid container>
					<Grid container style={{ overflowY: 'scroll' }}>
						<Grid item xs={12} sm={12} md={12} lg={12}>
							<ReportList callReportSaved={handleIsReportSaved} list={getDisplayList()} />
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		);
	}, [tabValue, savedReportsList, reportsList, reportTypeTabValue, sharedReportTabValue]);

	const TabsForProject = () => {
		return (
			<Box>
				<Tabs
					value={currentTab}
					classes={{
						root: classes.tabsRoot,
						indicator: classes.tabsIndicator
					}}
					indicatorColor="primary"
					onChange={(val, newVal) => {
						setCurrentTab(newVal);
						dispatch(setReportTypeTabValue(newVal));
						dispatch(dbSortBy(TABS[newVal].defaultSoryBy));
					}}>
					{TABS.map((item) => (
						<Tab
							id={item.label}
							label={item.label}
							key={item.label}
							classes={{ root: classes.tabRoot }}
							disabled={item.disabled}
						/>
					))}
				</Tabs>
				<TabPanel value={reportTypeTabValue} index={reportTypeTabValue}>
					{RenderReportList}
				</TabPanel>
			</Box>
		);
	};

	const TabsForSharedTab = () => {
		return (
			<Box>
				<Tabs
					value={currentSharedTab}
					classes={{
						root: classes.tabsRoot,
						indicator: classes.tabsIndicator
					}}
					indicatorColor="primary"
					onChange={(val, newVal) => {
						setCurrentSharedTab(newVal);
						dispatch(setSharedReportTabValue(newVal));
						dispatch(dbSortBy(SHARED_TAB[newVal].defaultSoryBy));
					}}>
					{SHARED_TAB.map((item) => (
						<Tab
							id={item.label}
							label={item.label}
							key={item.label}
							classes={{ root: classes.tabRoot }}
							disabled={item.disabled}
						/>
					))}
				</Tabs>
				<TabPanel value={reportTypeTabValue} index={reportTypeTabValue}>
					{RenderReportList}
				</TabPanel>
			</Box>
		);
	};

	/** If Dashboard doesn't have any reports to show */
	if (
		(tabValue === PROJECTS && reportsList.length === 0 && savedReportsList.length === 0) ||
		(tabValue === SHARED && sharedReportList.length === 0)
	) {
		return <NoDataPage />;
	}

	const RenderTab = () => {
		const _ret = {
			[PROJECTS]: <TabsForProject />,
			[SHARED]: <TabsForSharedTab />
		};

		return _ret[tabValue];
	};

	return (
		<Box style={{ marginTop: '24px' }} sx={{ width: '100%' }}>
			<Grid container direction="row">
				<Grid container>
					<Grid item xs={12} sm={6} md={6} lg={6}>
						<Box
							className={customerType == BASIC ? classes.searchReportBasic : classes.searchReport}>
							<SearchReport />
						</Box>
					</Grid>
					<Grid item xs={12} sm={6} md={6} lg={6}>
						<Box className={customerType == BASIC ? classes.newReportBasic : classes.newReport}>
							<NewReportButton />
						</Box>
					</Grid>
				</Grid>
				{RenderTab()}
			</Grid>
			<ShowErrorDialog
				openErrorMsg={openErrorMsg}
				errorMsgText={errorMsgText}
				cbOnDialogCancel={cbOnDialogCancel}
			/>
			<RBSnackbar
				doOpen={openSnackbar.open}
				msg={openSnackbar.msg}
				type={openSnackbar.type}
				doClose={() => {
					setSnackbar({ open: false, msg: '' });
				}}
				hideDuration={openSnackbar.hideDuration || 1000}
			/>
		</Box>
	);
}
DashboardMain.propTypes = {};

export default DashboardMain;
